<template>
    <div id="page" style="background-color: rgba(248, 248, 248, 1);">
        <div class="container">
            <img src="~@/assets/images/menu/商厨类碳标签banner.png" style="width: 100%;"/>
        </div>
        <section class="section" style="padding: 0;padding-bottom:0;" >
            <div class="container">
                <div class="row" style="padding:20px 0;" v-show="active==key[0]">
                    <template  v-for="(item,index) in list">
                        <div class="col-lg-3 col-md-6  col-sm-12 col-xs-12"  :key="index">
                            <router-link :to="{ path:'/shangchu/articleDetail',query:{id:item.id} }">
                                <div class="list-content">
                                    <img :src="item.mainImgResourceUrl" width="285" height="160"/>
                                    <div class="text-tip-1">{{item.title}}</div>
                                    <div class="text-tip-2"><span>{{getSpecialTime(item.releaseTime,"yyyy-MM-dd")}}</span><span><img src="~@/assets/images/menu/浏览icon.png" width="22" height="14"/>{{item.showViewsNum}}人浏览</span></div>
                                </div>
                            </router-link>
                        </div>
                    </template>
                    <div class="mt-3">
                        <b-pagination v-model="page.currentPage" :total-rows="page.rows" align="right"></b-pagination>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    import {articleList} from "@/api/home"
    import {getSpecialTime}  from "@/utils/tools"

    export default {
        name: "menu2_3",
        data() {
            return {
                active:"标准化要闻",
                page:{
                    rows:0,
                    currentPage:1
                },
                key:["标准化要闻","政府奖励奖金","碳标签资讯","标准制定问答","标准制定公告"],
                list:[]
            }
        },
        components: {},
        watch: {},
        mounted() {
            console.log("this.$route.params",this.$route.query)
            this.articleList()
        },
        created() {

        },
        methods: {
            getSpecialTime,
            activeChange(value){
                this.active=value
                this.list = []
                this.page.currentPage = 1
                this.page.rows=10
                this.articleList();
            },
            articleList(){

                let data={
                    parentTitle:"双碳3060",sonTitle:"各省市双碳政策"
                }
                articleList(data).then(res=>{
                    console.log(res)
                    this.list = res.data.records
                    this.page.rows=res.data.total
                })
            }
        }
    }
</script>

<style scoped>

    .container{
        max-width: 1200px;
        min-width: 375px;
    }



    .active-nav{
        height: 70px;
        background-color: rgba(2, 171, 57, 1);
        color: #ffffff;
    }
    .active-nav-1{
        height: 70px;
        line-height: 70px;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .list-content{
        width: 285px;
        background-color: #ffffff;
        padding-bottom:10px;
        margin-bottom: 15px;
    }
    .text-tip-1{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 400;
        font-size: 20px;
        color: #000000;
        line-height: 30px;
        padding: 10px 10px 5px 10px;
        height: 100px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3; /* 定义文本的行数 */
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .text-tip-2{
        padding: 5px 10px;
        display: flex;
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: 200;
        font-size: 16px;
        color: #888888;
        line-height: 30px;
    }
    .text-tip-2 span{
        flex:1;
    }
    .text-tip-2 span:nth-child(2){
        text-align: right;
    }
</style>
